
import Confetti from 'react-confetti';
import React, { useState, useEffect } from "react";
import { useWindowSize } from 'react-use';
import { FaChevronDown, FaChevronUp } from "react-icons/fa6";
import UnmetNeedsCard from "./UnmetNeedsCard";

// Celebration Page Component
const CelebrationPage = ({ selectedCards, onNext, unmetNeedsData, onBack, userId }) => {
  const { width, height } = useWindowSize();
  const [showConfetti, setShowConfetti] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowConfetti(false), 5000);
    return () => clearTimeout(timer);
  }, []);

  // useEffect(() => {
  //   const timer = setTimeout(() => onNext(), 4000);
  //   return () => clearTimeout(timer);
  // }, [onNext]);

  return (
    <div className="min-h-[85vh] flex flex-col p-2 bg-white relative w-full">
    <div className="flex flex-col justify-center items-center p-2 relative">
      {showConfetti && (
        <Confetti
          width={width}
          height={height}
          numberOfPieces={200}
          recycle={true}
          colors={['#54B0AF', '#469F9E', '#E0F7F7', '#B8E6E6', '#FFD700', '#FF6B6B']}
        />
      )}
      <div className="text-center z-10 max-w-3xl">
        <h1 className="text-2xl md:text-2xl font-medium text-[#323232] font-gotham mb-2 animate-bounce">
          Kudos on reaching the 2nd milestone in your journey – discovering your unmet needs
        </h1>
      {/* <UnmetNeedsCard selectedCards={selectedCards} unmetNeedsData={unmetNeedsData} /> */}
      <UnmetNeedsCard userId={userId}  />

      </div>
    </div>
    {/* Right side - Navigation buttons (up/down) */}
                    <div className="flex items-center justify-end gap-2 absolute -right-28 bottom-0">
                      <button
                        onClick={onBack}
                        className="inline-flex items-center gap-2 px-2 py-2 font-gotham bg-[#B6B6B6] rounded-full hover:bg-[#54B0AF] font-medium transition-all disabled:opacity-30 disabled:cursor-not-allowed"
                      >
                        <FaChevronUp className="w-4 h-4 font-gotham -rotate-90 text-white" />
                      </button>
                  
                      <button
                        onClick={onNext}
                        className="inline-flex items-center gap-2 px-2 py-2 font-gotham bg-[#B6B6B6] rounded-full hover:bg-[#54B0AF] font-medium transition-all disabled:opacity-30"
                      >
                        <FaChevronDown className="w-4 h-4 font-gotham -rotate-90 text-white" />
                      </button>
                    </div>
      </div>
  );
};

export default CelebrationPage;